module.exports = __webpack_public_path__ + "static/media/ant.67bd6fc5.svg";